var React = require('react');

function SocialYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.8185 17.1237C21.7019 17.5745 21.4732 17.9856 21.1553 18.3159C20.8374 18.6461 20.4415 18.884 20.0071 19.0056C18.4085 19.4518 12.0001 19.4518 12.0001 19.4518C12.0001 19.4518 5.59164 19.4518 3.99296 19.008C3.55846 18.8868 3.16235 18.649 2.8444 18.3187C2.52645 17.9884 2.29787 17.5771 2.18159 17.126C1.75391 15.4648 1.75391 12 1.75391 12C1.75391 12 1.75391 8.53518 2.18159 6.87634C2.41716 5.9603 3.11244 5.23885 3.99296 4.99442C5.59164 4.54826 12.0001 4.54826 12.0001 4.54826C12.0001 4.54826 18.4085 4.54826 20.0071 4.99442C20.89 5.23885 21.583 5.9603 21.8185 6.87634C22.2462 8.53518 22.2462 12 22.2462 12C22.2462 12 22.2462 15.4648 21.8185 17.1237ZM9.96455 8.81996V15.1801L15.2706 12.0237L9.96455 8.81996Z","fill":"currentColor"}));
}

SocialYoutube.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = SocialYoutube;

SocialYoutube.default = SocialYoutube;
